/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FaecherInputs */

const de__field_faecher = /** @type {(inputs: _Field_FaecherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fächer`)
};

/**

* @param {_Field_FaecherInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_faecher = /** @type {((inputs?: _Field_FaecherInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FaecherInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_faecher(inputs)
});